import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { isEmpty } from 'lodash'
import { Trans } from 'react-i18next'
import I18n from 'translations/i18n'
import { TextInputField } from 'components/final-form'
import { Text, Button, Spacer } from '@jisr-hr/design-system'

import { calculateTimeLeft } from 'containers/authorised/payroll/LandPage/components/Reminder/helper'

const VerificationForm = ({ fetching, initialValues, timerMinutes, onSubmit }) => {
  const [timeLeft, setTimeLeft] = React.useState({})

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(timerMinutes))
    }, 1000)

    return () => clearTimeout(timer)
  })

  React.useEffect(() => {
    setTimeLeft(calculateTimeLeft(timerMinutes))
  }, [timerMinutes])

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
    >
      {({ handleSubmit, submitting, values }) => (
        <form style={{ padding: 20 }}>
          <Text
            as="span"
            typography="caption12"
          >
            {I18n.t('login_six_digit_code_note')}
          </Text>
          <Spacer height="28px" />
          <TextInputField
            name="otp_code"
            type="text"
            label={I18n.t('enter_six_digit_code')}
          />
          <Button
            disabled={fetching || submitting || isEmpty(timeLeft) || !values.otp_code}
            label={I18n.t('confirm')}
            type="submit"
            onClick={handleSubmit}
            size="medium"
            style={{ width: '100%', justifyContent: 'center' }}
          />
          <div style={{ marginTop: 20 }}>
            {!isEmpty(timeLeft) ? (
              <Text
                typography="caption12"
                style={{ textAlign: 'center' }}
              >
                <Trans
                  i18nKey="code_valid_until"
                  components={{ b: <b /> }}
                  values={{ time: `${timeLeft.minutes}:${timeLeft.seconds}` }}
                />
              </Text>
            ) : (
              <Button
                disabled={fetching || submitting}
                label={I18n.t('resend_new_code')}
                onClick={() =>
                  onSubmit({
                    login: values.login,
                    password: values.password,
                  })
                }
                style={{ margin: 'auto' }}
                variant="tertiary"
                size="small"
              />
            )}
          </div>
        </form>
      )}
    </Form>
  )
}

VerificationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
  initialValues: PropTypes.shape(),
  timerMinutes: PropTypes.shape(),
}

export default VerificationForm
